import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const cockpitDocumentsWidgets = makeDynamicConfigWidgets([
  {
    name: 'cockpitDocuments',
    cols: 12,
    props: {
      title: 'cockpit_documents_widget_title',
      showCategories: true,
      showFileTypes: true,
      showUploadDates: true,
      showFileSizes: true,
      showDownloadButtons: true,
      showPreview: true,
    },
  },
]);
